import {
	useEffect, useState,
} from 'react'

import {
	getFirestore, doc, onSnapshot,
} from 'firebase/firestore'

import { isNil } from 'lodash'
import { toDate } from '../utils/firebase'
import { CustomizedToken } from '../@types/customizedToken'

 interface IHookOutput {
  error: Error | string | null
  customizedToken: CustomizedToken | null
}

// ---------------------------------------------------------------------

const useCustomizedToken = (id:string | null): IHookOutput => {
	const [error, setError] = useState<Error | string | null>(null)
	const [customizedToken, setCustomizedToken] = useState<CustomizedToken | null>(null)

	useEffect(() => {
		if (!isNil(id)) {
			const db = getFirestore()
			const docRef = doc(db, 'customizedTokens', id)
			const unsubscribe = onSnapshot(docRef, (doc) => {
				if (!doc.exists()) {
					setError('Custom User Token does not exists')
				} else {
					const response = {
						id,
						...doc.data(),
						createdOn: doc.data()?.createdOn ? toDate(doc.data().createdOn) : undefined,
						updatedOn: doc.data()?.updatedOn ? toDate(doc.data().updatedOn) : undefined,
					} as CustomizedToken
					// console.log('Current Customized NFT Data: ', JSON.stringify(response))
					setCustomizedToken(response)
				}
			})
			return () => unsubscribe()
		}
		return () => {}
	}, [id])

	return {
		error,
		customizedToken,
	}
}

export default useCustomizedToken
